import React, { useState, useEffect } from 'react';
import { Flex } from 'rebass/styled-components';
import { Input } from '@rebass/forms';
import theme from '../../theme';

const VerificationCode = ({ setCode, current, setCurrent }) => {
  const [valuesCode, setValuesCode] = useState({
    phoneVerificationCell1: '',
    phoneVerificationCell2: '',
    phoneVerificationCell3: '',
    phoneVerificationCell4: '',
    phoneVerificationCell5: '',
    phoneVerificationCell6: ''
  });

  useEffect(() => {
    if (
      current == 'phoneVerificationCell1' ||
      current == 'phoneVerificationCell2' ||
      current == 'phoneVerificationCell3' ||
      current == 'phoneVerificationCell4' ||
      current == 'phoneVerificationCell5' ||
      current == 'phoneVerificationCell6'
    ) {
      document.getElementById(current).focus();
      document.getElementById(current).select();
    }
  }, [current]);

  const changeValuesHandler = e => {
    setValuesCode({ ...valuesCode, [e.target.name]: e.target.value });

    if (e.target.value != '') {
      switch (e.target.name) {
        case 'phoneVerificationCell1':
          setCurrent('phoneVerificationCell2');
          break;
        case 'phoneVerificationCell2':
          setCurrent('phoneVerificationCell3');
          break;
        case 'phoneVerificationCell3':
          setCurrent('phoneVerificationCell4');
          break;
        case 'phoneVerificationCell4':
          setCurrent('phoneVerificationCell5');
          break;
        case 'phoneVerificationCell5':
          setCurrent('phoneVerificationCell6');
          break;
        default:
          break;
      }
    }
  };

  useEffect(() => {
    let code =
      valuesCode.phoneVerificationCell1 +
      valuesCode.phoneVerificationCell2 +
      valuesCode.phoneVerificationCell3 +
      valuesCode.phoneVerificationCell4 +
      valuesCode.phoneVerificationCell5 +
      valuesCode.phoneVerificationCell6;
    setCode(code);
  }, [valuesCode]);

  window.addEventListener('paste', e => {
    var clipboardData, pastedData;

    e.stopPropagation();
    e.preventDefault();

    clipboardData = e.clipboardData || window.clipboardData;
    pastedData = clipboardData.getData('Text');
    const codeChars = [...pastedData];
    let valuesCodePaste = {};
    codeChars.map((element, index) => {
      let n = index + 1;
      valuesCodePaste['phoneVerificationCell' + n] = element;
    });

    setValuesCode(valuesCodePaste);
  });

  return (
    <Flex pb={4}>
      <Input
        id="phoneVerificationCell1"
        name="phoneVerificationCell1"
        type="text"
        onChange={changeValuesHandler}
        value={valuesCode.phoneVerificationCell1}
        maxLength="1"
        placeholder="*"
        width="50px"
        sx={{
          color: `${theme.colors.main}`,
          backgroundColor: `#FFFFFF`,
          fontSize: `24px`,
          border: `0`,
          border: `1px solid RGBA(114,109,225,0.3)`,
          outline: `none`,
          padding: `1x`,
          marginRight: `3px`,
          textAlign: `center`,
          '&: focus': {
            borderBottom: `2px solid ${theme.colors.main}`
          },
          ':: placeholder': {
            color: `${theme.colors.main}`,
            opacity: `0.3`
          }
        }}
      />
      <Input
        id="phoneVerificationCell2"
        name="phoneVerificationCell2"
        type="text"
        onChange={changeValuesHandler}
        value={valuesCode.phoneVerificationCell2}
        maxLength="1"
        placeholder="*"
        width="50px"
        sx={{
          color: `${theme.colors.main}`,
          backgroundColor: `#FFFFFF`,
          fontSize: `24px`,
          border: `0`,
          border: `1px solid RGBA(114,109,225,0.3)`,
          outline: `none`,
          padding: `1px`,
          marginRight: `3px`,
          textAlign: `center`,
          '&: focus': {
            borderBottom: `2px solid ${theme.colors.main}`
          },
          ':: placeholder': {
            color: `${theme.colors.main}`,
            opacity: `0.3`
          }
        }}
      />
      <Input
        id="phoneVerificationCell3"
        name="phoneVerificationCell3"
        type="text"
        onChange={changeValuesHandler}
        value={valuesCode.phoneVerificationCell3}
        maxLength="1"
        placeholder="*"
        width="50px"
        sx={{
          color: `${theme.colors.main}`,
          backgroundColor: `#FFFFFF`,
          fontSize: `24px`,
          border: `0`,
          border: `1px solid RGBA(114,109,225,0.3)`,
          outline: `none`,
          padding: `1px`,
          marginRight: `3px`,
          textAlign: `center`,
          '&: focus': {
            borderBottom: `2px solid ${theme.colors.main}`
          },
          ':: placeholder': {
            color: `${theme.colors.main}`,
            opacity: `0.3`
          }
        }}
      />
      <Input
        id="phoneVerificationCell4"
        name="phoneVerificationCell4"
        type="text"
        onChange={changeValuesHandler}
        value={valuesCode.phoneVerificationCell4}
        maxLength="1"
        placeholder="*"
        width="50px"
        sx={{
          color: `${theme.colors.main}`,
          backgroundColor: `#FFFFFF`,
          fontSize: `24px`,
          border: `0`,
          border: `1px solid RGBA(114,109,225,0.3)`,
          outline: `none`,
          padding: `1px`,
          marginRight: `3px`,
          textAlign: `center`,
          '&: focus': {
            borderBottom: `2px solid ${theme.colors.main}`
          },
          ':: placeholder': {
            color: `${theme.colors.main}`,
            opacity: `0.3`
          }
        }}
      />
      <Input
        id="phoneVerificationCell5"
        name="phoneVerificationCell5"
        type="text"
        onChange={changeValuesHandler}
        value={valuesCode.phoneVerificationCell5}
        maxLength="1"
        placeholder="*"
        width="50px"
        sx={{
          color: `${theme.colors.main}`,
          backgroundColor: `#FFFFFF`,
          fontSize: `24px`,
          border: `0`,
          border: `1px solid RGBA(114,109,225,0.3)`,
          outline: `none`,
          padding: `1px`,
          marginRight: `3px`,
          textAlign: `center`,
          '&: focus': {
            borderBottom: `2px solid ${theme.colors.main}`
          },
          ':: placeholder': {
            color: `${theme.colors.main}`,
            opacity: `0.3`
          }
        }}
      />
      <Input
        id="phoneVerificationCell6"
        name="phoneVerificationCell6"
        type="text"
        onChange={changeValuesHandler}
        value={valuesCode.phoneVerificationCell6}
        maxLength="1"
        placeholder="*"
        width="50px"
        sx={{
          color: `${theme.colors.main}`,
          backgroundColor: `#FFFFFF`,
          fontSize: `24px`,
          border: `0`,
          border: `1px solid RGBA(114,109,225,0.3)`,
          outline: `none`,
          padding: `1px`,
          marginRight: `3px`,
          textAlign: `center`,
          '&: focus': {
            borderBottom: `2px solid ${theme.colors.main}`
          },
          ':: placeholder': {
            color: `${theme.colors.main}`,
            opacity: `0.3`
          }
        }}
      />
    </Flex>
  );
};

export default VerificationCode;
